export default __webpack_public_path__ + "static/media/wifi.cc77d7fd.svg";